import { ReactNode } from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'
import { ctaClassNames } from '../CtaLink/CtaLink'

type CtaButtonProps = WithClassName<{
	text: string
	icon?: ReactNode
	variant?: 'primary' | 'outline'
	compact?: boolean
	onClick: () => void
}>

export const CtaButton = ({
	text,
	icon = <PlusIcon />,
	variant = 'primary',
	compact = false,
	className,
	onClick
}: CtaButtonProps) => {
	const isIconOnlyOnMobile = compact && !!icon

	return (
		<button
			type="button"
			aria-label={isIconOnlyOnMobile ? text : undefined}
			className={cn(
				ctaClassNames.base,
				ctaClassNames[variant],
				isIconOnlyOnMobile && 'w-9 px-0 sm:w-auto sm:px-4',
				className
			)}
			onClick={onClick}>
			{icon}
			<span className={isIconOnlyOnMobile ? 'hidden sm:inline' : undefined}>{text}</span>
		</button>
	)
}
